// Network (IP) location → place names + rough coordinates, cached on device for a day.
// No permission prompt: the lookup runs from the viewer's own connection.
const KEY = "tain-network-location";
const DAY = 24 * 3600 * 1000;
const EMPTY = { places: [], lat: null, lng: null };

function cached() {
  try {
    const c = JSON.parse(localStorage.getItem(KEY));
    if (c && Date.now() - c.at < DAY) return c.loc;
  } catch { /* ignore */ }
  return null;
}

export function cachedLocation() {
  return cached() || EMPTY;
}

async function fetchJson(url) {
  const ctrl = new AbortController();
  const t = setTimeout(() => ctrl.abort(), 6000);
  try {
    const r = await fetch(url, { signal: ctrl.signal });
    return await r.json();
  } finally {
    clearTimeout(t);
  }
}

async function lookup() {
  try {
    const d = await fetchJson("https://api.bigdatacloud.net/data/reverse-geocode-client?localityLanguage=en");
    const places = [d.locality, d.city, d.principalSubdivision, d.countryName].filter(Boolean);
    if (places.length) return { places: [...new Set(places)], lat: d.latitude ?? null, lng: d.longitude ?? null };
  } catch { /* try fallback */ }
  try {
    const d = await fetchJson("https://ipwho.is/");
    if (d.success !== false) {
      const places = [d.city, d.region, d.country].filter(Boolean);
      return { places: [...new Set(places)], lat: d.latitude ?? null, lng: d.longitude ?? null };
    }
  } catch { /* ignore */ }
  return null;
}

export async function getNetworkLocation() {
  const hit = cached();
  if (hit) return hit;
  const loc = await lookup();
  if (!loc) return EMPTY;
  localStorage.setItem(KEY, JSON.stringify({ loc, at: Date.now() }));
  return loc;
}

export function spotParams(loc) {
  return {
    ...(loc.places.length ? { places: loc.places.slice(0, 6).join(",") } : {}),
    ...(loc.lat != null && loc.lng != null ? { lat: loc.lat, lng: loc.lng } : {}),
  };
}
